(function ($) {
    'use strict';
    $.widget("fd.control_select", {
        options: {
            parentid: null,
            callback: function () { },
            initial: null,
            placeholder: 'Select',
            allowsearch: true,
            allowclear: false,
            dropdownautowidth: true,
            unselectedvalue: "0",
            minimuminputlength: 2,      // Only used with ajax
            dropdownParent: 'body',     // Override with something more specific if you're running into display issues
            provider: null,             // Ajax url if default settings are acceptable (param = "term", returns object with fields ID and Text)
            ajaxbuilder: null,          // Provide function that will return a custom object to be passed in the select2 ajax field (ignored if provider has a value)
            namespace: 'Page',          // Used for the ajaxbuilder and callback functions
            cascadeparentid: null,      // Used when this select element should be reset/reloaded when other select changes
            cascadeprovider: null,      // Ajax url used when reset/reload is triggered by cascade          
            cascadeajaxbuilder: null,   // Provider function to build cascade ajax
            allowcustom: false,         // Used to allow the custom options to be entered into a multi-select
            createtagcallback: null,
            matchercallback: null,      // do a custom search via a function, (params, data) => { return data; }

            // these three for custom HTML
            templateresultcallback: null,
            templateselectioncallback: null,
            escapemarkupcallback: null
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }
            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);
        },
        _create: function () {
            const self = this;
            if (!self.options.parentid) {
                self.options.parentid = self.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            // work-around to disabled select2 element when fieldset ancestor is disabled. 
            const fieldset = self.element.closest('fieldset');
            if (fieldset.length) {
                if (fieldset.prop('disabled')) {
                    // need to check that fieldset is disabled because if we don't we may override the select's prop on page load
                    self.element.prop('disabled', fieldset.prop('disabled'));
                }
                fieldset.on('disabled', function (ev) {
                    if (ev.target === ev.currentTarget) {
                        self.element.prop('disabled', true);
                    }
                }).on('enabled', function (ev) {
                    if (ev.target === ev.currentTarget) {
                        self.element.prop('disabled', false);
                    }
                });
            }
            this.initial(this.element.val());

            // Convert numeric options
            this.options.delay = Number(this.options.minlength);
            this.options.minimuminputlength = Number(this.options.minimuminputlength);

            const select2Options = {
                minimumInputLength: this.options.ajaxbuilder || this.options.provider ? this.options.minimuminputlength : 0,
                placeholder: this.options.placeholder,
                dropdownParent: this.options.dropdownParent,
                dropdownAutoWidth: this.options.dropdownautowidth,
                allowClear: this.options.allowclear,
                tags: this.options.allowcustom
            };
            if (this.options.createtagcallback) {
                select2Options.createTag = this.options.createtagcallback;
            }
            if (this.options.matchercallback) {
                select2Options.matcher = this.options.matchercallback;
            }
            if (this.options.templateresultcallback) {
                select2Options.templateResult = this.options.templateresultcallback;
            }
            if (this.options.templateselectioncallback) {
                select2Options.templateSelection = this.options.templateselectioncallback;
            }
            if (this.options.escapemarkupcallback) {
                select2Options.escapeMarkup = this.options.escapemarkupcallback;
            }
            if (this.options.allowsearch === "false" || !this.options.allowsearch) {
                select2Options.minimumResultsForSearch = Infinity;
            }
            if (this.options.provider) {
                select2Options.ajax = {
                    url: this.options.provider,
                    dataType: 'json'
                };
            } else if (this.options.ajaxbuilder && typeof (FD[this.options.namespace][this.options.ajaxbuilder]) === 'function') {
                select2Options.ajax = FD[this.options.namespace][this.options.ajaxbuilder].call(this);
            }

            this.element[0].initiallyDisabled = this.element[0].disabled;
            this.element[0].fdUnselect = function () {
                self._unselect(select2Options);
            };
            this.element[0].fdResetSelectedItem = function (item) {
                self._resetSelectedItem(select2Options, item);
            };

            this._createCascadeEffect(select2Options);
            this.element.select2(select2Options);
            if (this.element.attr('multiple')) {
                this._applyOptionStyles();
            }
            this._setEvents();
            this.select2Options = select2Options;
        },
        _createCascadeEffect: function (select2Options) {
            if (!this.options.cascadeparentid || !(this.options.cascadeprovider || this.options.cascadeajaxbuilder)) {
                return;
            }

            var self = this;
            $('#' + self.options.cascadeparentid).on('change', function (e) {
                var parentValue = $(this).val();
                var url = null;
                if (self.options.cascadeajaxbuilder) {
                    var callback = FD[self.options.namespace][self.options.cascadeajaxbuilder];
                    url = callback(parentValue, self.options.cascadeprovider + "?");
                } else {
                    url = self.options.cascadeprovider + "?id=" + parentValue;
                }

                if (!parentValue || parentValue === self.options.unselectedvalue) {
                    self._loadSelectItems(url, select2Options, []);
                } else {
                    $.getJSON(url, function (items) {
                        self.itemToSelectAfterCascade = items.results.find(s => s.id == self.element.val());
                        self._loadSelectItems(url, select2Options, items);
                    });
                }
            });
        },
        _unselect: function (select2Options) {
            this.element.val(this.options.unselectedvalue).trigger('change');
            if (this.element[0].initiallyDisabled) {
                select2Options.disabled = true;
            }

            this.element.select2(select2Options);
        },
        _loadSelectItems: function (sourceUrl, select2Options, items) {
            const self = this;
            items = items.results ? items.results : items;
            items = items instanceof Array ? items : [items];
            this.items = items;
            this.items.timestamp = new Date();
            let clearSelect = this.options.allowclear

            function makeItems(data) {
                let html = ''
                self.element.find('[data-persistant=true]').each((idx, item) => html += $(item)[0].outerHTML);
                for (var i = 0; i < data.length; i++) {
                    const item = data[i];

                    if (item.children) {
                        html += '<optgroup label="' + item.text + '">' + makeItems(item.children) + '</optgroup>';
                    } else {
                        let selectedAttr = "";
                        const isSelected = item.selected || (self.itemToSelectAfterCascade && self.itemToSelectAfterCascade.id === item.id);
                        if (isSelected) {
                            selectedAttr = "selected";
                            clearSelect = false;
                            self.itemToSelectAfterCascade = null;
                        }
                        html += '<option value="' + item.id + '" ' + selectedAttr + '>' + item.text + '</option>';
                    }
                }
                return html
            }

            select2Options.disabled = false;
            this.element
                .select2('destroy')
                .html(makeItems(items))
                .select2(select2Options);

            if (clearSelect) {
                this.element.val(null).trigger('change')
            }
        },
        _resetSelectedItem: function (select2Options, item) {
            var isAjax = this.options.ajaxbuilder || this.options.provider;
            if (isAjax) {
                this.element
                    .select2('trigger', 'select', { data: item });
                return;
            }

            if (this.options.cascadeprovider || this.options.cascadeajaxbuilder) {
                this.itemToSelectAfterCascade = item;
                return;
            }
        },
        _applyOptionStyles: function () {
            var self = this.element;
            this.element.children("[class|=bg]:not(.bg-none)").each(function () {
                let cssClass = $(this).attr('class');
                let bgColor = $("<div class='color-working'>").appendTo("body").addClass(cssClass).css("background-color");
                self.next().find(".select2-selection__choice[title='" + $(this).text() + "'],.select2-selection__choice[data-original-title='" + $(this).text() + "']").css("background-color", bgColor);
            });
            $("body>.color-working").remove();
        },
        _handleChange: function (event) {
            const self = event.data;

            if (!self.element.val()) {
                // select2 doesn't change the original title on clear
                const $select2 = self.element.next();
                $select2.find('[data-original-title]').attr('data-original-title', '').tooltip('hide');
                $select2.find(".select2-selection__clear").tooltip('hide');
            }

            self._didSubmit = false;
            setTimeout(() => {
                if (!self._didSubmit) {
                    self._handleSubmit(event);
                }
            })
        },
        _handleSelect: function (event) {
            const self = event.data;
            self._didSubmit = true;
            self._handleSubmit(event);
        },
        _handleSubmit: function (event) {
            this.options.callback.call(this, {
                parentid: this.options.parentid,
                value: this.element.val(),
                param: event.params ? event.params.data : null
            }, event);
            this.element.blur();
            if (this.element.attr('multiple')) {
                this._applyOptionStyles();
            }
        },
        _setEvents: function () {
            this.element.off('change.fdcontrol').on('change.fdcontrol', null, this, this._handleChange);
            this.element.off('select2:select').on('select2:select', null, this, this._handleSelect);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
            if (key == 'allowcustom') {
                this.select2Options.tags = this.options.allowcustom;
                this.element.select2(this.select2Options);
            }
        },
        _destroy: function () {
            this.element.select2('destroy');
        },
        updateOption: function (value, text, disabled) {
            const option = this.element.find('option[value=' + value + ']');
            if (option.length) {
                if (text && option.val() !== text) {
                    option.text(text);
                    this.element.control_select('destroy').control_select(this.options);
                }
                if (disabled === true || disabled === false) {
                    option.attr('disabled', disabled);
                }
            } else {
                const newOption = new Option(text, value, false, true);
                if (disabled === true || disabled === false) {
                    $(newOption).attr('disabled', disabled);
                }
                this.element.append(newOption).trigger('change');
            }
        },
        replaceOptions: function (options, valueField, textField, selectedValue) {
            valueField = !valueField ? 'Id' : valueField;
            textField = !textField ? 'Name' : textField;
            this.element.find('option:not([data-persistant=true])').remove();
            for (let i = 0; i < options.length; i++) {
                this.element.append(`<option value="${options[i][valueField]}">${options[i][textField]}</option>`);
            }
            if (typeof selectedValue !== 'undefined') {
                this.element.val(selectedValue);
            }
        },
        reset: function () {
            if (this.options.ajaxbuilder || this.options.provider) {
                this.element.find('option:not([data-persistant=true])').remove();
            }
        },
    });
}(jQuery));